import { formatDate, formatMoney, formatNumber } from './format';
import { t } from './t';
import type { TFunction } from './translate';

/** `t('nav.shop')`, `t('footer.rights', { year: 2026 })` — one stable function, the same everywhere. */
export function useT(): TFunction {
  return t;
}

const FORMATTERS = { formatNumber, formatDate, formatMoney } as const;

/** `Intl` helpers for the site's one language (en-IN): numbers, dates and money. */
export function useFormatters(): typeof FORMATTERS {
  return FORMATTERS;
}
